import React, { useState } from 'react';
import InputForm from '../../../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../../Types/ParamsPicklist';
import { Box, CircularProgress, TextField, Tooltip, Typography } from '@mui/material';
import { Button, Input, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Clear, DataArray, MonetizationOn, MonetizationOnOutlined, Money, Phone, SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../../Models/Utilisateur';
import SearchInput from '../../../../SearchInput';
import CheckBox from '../../../../CheckBox';
import SearchModal from '../../../../SearchModal';
import RadioBox from '../../../../Radiox';
import TextArea from 'antd/es/input/TextArea';
import Datas from "../../../../../Data/Data.json"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import axios from 'axios';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import SweetAlert from "sweetalert2"
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import Data from '../../../../../Data/Data.json'
import { DownOutlined } from '@ant-design/icons';
import Spin from 'antd/es/spin';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../../TableResizable';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import styled from '@emotion/styled';







//Initialisation des parametres de recherche
//

interface SelectData {
  value: string,
  label: string,
}

function Tab2(props: { form?: any,data:any[] }) {
  // USER SESSION

  const [loading, setLoading] = useState(false)

  const columns: ColumnsType<any> = [
    {
      title: 'Date Decaissement',
      dataIndex: 'DateDecaissement',
    },
    {
      title: 'Id décaissement',
      dataIndex: 'DecaissementID',
    },
    {
      title: 'Montant Decaisse',
      dataIndex: 'MontantDecaisse',
    
    },
    {
      title: 'Compte Source',
      dataIndex: 'CompteSource',
      
    },
    {
      title: 'Compte Destination',
      dataIndex: 'CompteDestination',
     
    },
    {
      title: 'Reference Operation',
      dataIndex: 'ReferenceOperation',
    },
    {
      title: 'Raison',
      dataIndex: 'Observation',
    },
    {
      title: 'Utilisateur',
      dataIndex: 'CreePar',
    }
  ];

  

   

  return (

    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border' height={"60%"} width={"85%"} position={"absolute"}>
          <div className='clientP'>
            <div >
              <Box position={"relative"} fontStyle="inherit" width={"99%"} className='border-left tabElement'>
                <Spin spinning={loading}>
                  <Table size='small' style={{ width: "100%" }} columns={columns} dataSource={props.data} scroll={{ y: 250, x: 10 }} pagination={false} />
                </Spin>
                <Box display={"flex"} fontStyle={"inherit"}  width={'100%'}>
                  <InputForm money notRequired  icon={<MonetizationOnOutlined fontSize='small' />} width={5} label='Nombre de décaissement' name='NbDec' type='text' error='mobile' />
                  <InputForm money notRequired disabled width={5} label='Montant total décaissé' icon={<MonetizationOnOutlined fontSize='small' />} name='Mntdecaisse' type='text' error='mobile' />
                </Box>
              </Box>
            </div>
            <div>
            </div>
          </div>
        </Box>
      </div>
    </div>

  )
}
export default Tab2;

// values.NUMCLI, values.PERIODIC, values.MONTEPARG, values.TAUXINT, values.NBPERDIF, values.TYPEPRET, values.TYPAMORT, values.TAUXEPAR, values.NBRECHE, values.MONTAN, values.TYPCALC, values.TAUXTAX, ReformatDate(values.DAT1ECHE), values.MTNCOM1 + values.MTNCOM2 + values.MTNCOM3 + values.MTNCOM4 + values.MTNCOM5